module.exports = __webpack_public_path__ + "img/assurPlus.3b5d8ff7.jpg";